<template>
  <div class="az-form-content">
    <v-container fluid grid-list-xl>
      <v-flex xs12 sm12 d-block class="card-dados" v-if="eventos && eventos.length > 0" :eventos="eventos">
        <h3 class="card-dados__titulo mb-0">Alterações Após Publicação</h3>
        <v-timeline align-top dense class="mx-3">
          <v-timeline-item v-for="evento in eventos" :key="evento.id"
                           :icon="selecionarIcone(evento)"
                           icon-color="#777777"
                           color="#EBEBEB"
                           fill-dot small>
            <v-layout>
              <v-flex class="conteudo-evento az-text pl-0 mt-2">
                <div>
                  <strong>{{selecionarTituloEvento(evento)}}</strong>
                  <span>
                    - {{ evento.dataCadastro | az-date(humanizarFormatoDataHora(evento.dataHoraAnterior))}}
                  </span>
                </div>
                <div v-if="!('PUBLICACAO' === evento.tipo || 'ANEXOS' === evento.tipo)">
                  <strong >Motivo: </strong> {{evento.motivo}}
                </div>
              </v-flex>
            </v-layout>
          </v-timeline-item>
        </v-timeline>
      </v-flex>
      <h3 v-else class="card-dados__titulo mb-0">Não Há Alterações.</h3>
    </v-container>
  </div>
</template>
<script>
import {mapState} from "vuex";

export default {
    name: 'CredenciamentoTimelineEventosPosPublicacao',
    computed:{
      eventos() {
        return this.licitacao.eventosPosPublicacao
      },
      ...mapState(['licitacao'])
    },
    methods:{
        selecionarIcone(evento){
            if(evento.tipo === 'DESPUBLICACAO')
                return 'block'
            return null
        },
        selecionarTituloEvento(evento){
            if(evento.tipo === 'DESPUBLICACAO')
                return 'Compra Despublicada'
            if(evento.tipo === 'PUBLICACAO')
              return 'Compra publicada'
            return null
        }
    }
}
</script>

<style lang="stylus">
    .conteudo-evento
        color #888888
        strong
            color #777777
    .card-dados
      border 1px solid #ebebeb
      margin 0 auto 2rem
      border-radius 2px

      tr
        border-bottom 1px solid #e7e7e7 !important

      &__titulo
        font-size 1.1rem
        color #777
        padding .6rem .8rem
        border-bottom 1px solid #ebebeb
        background-color #ebebeb
        box-sizing border-box
        margin-bottom .6rem

      .layout
        margin 0 !important

      .az-table-list .v-table tbody tr:nth-child(even)
        background-color #f9f9f9

    .card-dados__titulo
      font-size 1rem
</style>
